import Axios from "axios";
import token from "./setToken";

export default {
  async getData(surveyId, memberNo, branch) {
    try {
      // await token.checkToken();
      const res = await Axios.get("/api/RefrigerantAnswer/" + surveyId + "/" + memberNo + "/" + branch, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査回答を取得できません[getData]");
      throw error;
    }
  },

  async setData(surveyDatas, surveyId, memberNo, contactData, branch, qaList) {
    let params = new URLSearchParams();
    params.append("surveyDatas", JSON.stringify(surveyDatas));
    params.append("surveyId", surveyId);
    params.append("memberNo", memberNo);
    params.append("contactData", JSON.stringify(contactData));
    params.append("branch", branch);
    params.append("qaList", JSON.stringify(qaList));

    try {
      // await token.checkToken();
      const res = await Axios.post("/api/RefrigerantAnswer", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査回答を設定できません[setData]");
      throw error;
    }
  },

  async setBranch(item) {
    let params = new URLSearchParams();
    params.append("item", JSON.stringify(item));

    try {
      // await token.checkToken();
      const res = await Axios.post("/api/RefrigerantAnswerBranch", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査回答区分を設定できません[setBranch]");
      throw error;
    }
  },

  async setStatus(surveyId, memberNo, branch, contactData) {
    let params = new URLSearchParams();
    params.append("surveyId", surveyId);
    params.append("memberNo", memberNo);
    params.append("branch", branch);
    params.append("contactData", JSON.stringify(contactData));

    try {
      // await token.checkToken();
      const res = await Axios.post("/api/RefrigerantAnswerStatus", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("ステータスを保存できません[setStatus]");
      throw error;
    }
  },

  async delBranch(surveyId, memberNo, branch) {
    try {
      // await token.checkToken();
      const res = await Axios.delete("/api/RefrigerantAnswerBranchDelete/"+surveyId+"/"+memberNo+"/"+branch, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査回答区分を削除できません[delBranch]");
      throw error;
    }
  },

  async updateBulkStatus(updateList, status) {
    let params = new URLSearchParams();
    params.append("updateList", JSON.stringify(updateList));
    params.append("status", JSON.stringify(status));
 
    try {
      // await token.checkToken();
      const res = await Axios.post("/api/RefrigerantAnswerBulkStatus", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査回答ステータスを変更できません[updateBulkStatus]");
      throw error;
    }
  },
};
